import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Typography,
  Layout,
  message,
  Switch,
} from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
// import { toast, Toaster } from "react-hot-toast";
import LogoIndak from "../../../assets/img/indak-company2.jpg";
import LoginImage from "../../../assets/img/indak-company3.jpg";
import { encryptData } from "../../../utils/crypt";
import axios from "axios";
import { BASE_API } from "../../../setup/application.properties";

const { Title, Text, Link } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const [prefersDark, setPrefersDark] = useState(false);
  const [manualTheme, setManualTheme] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const saved = localStorage.getItem("loginTheme");
    if (saved === "dark" || saved === "light") {
      setManualTheme(saved);
    }
    const mq = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => setPrefersDark(!!(mq && mq.matches));
    if (mq) {
      apply();
      if (mq.addEventListener) mq.addEventListener("change", apply);
      else mq.addListener(apply);
      return () => {
        if (mq.removeEventListener) mq.removeEventListener("change", apply);
        else mq.removeListener(apply);
      };
    }
    return undefined;
  }, []);
  const currentTheme = manualTheme ? manualTheme : prefersDark ? "dark" : "light";
  const resetThemeAuto = () => {
    setManualTheme(null);
    localStorage.removeItem("loginTheme");
  };
  const onFinish = async (values) => {
    const { username, password } = values;
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_API}/auth/login`, {
        UserName: username,
        Password: password,
      });

      const {
        token,
        nickname,
        roleAccess,
        nama
      } = response.data;

      localStorage.setItem("token", encryptData(token));
      localStorage.setItem("nickname", encryptData(nama));
      localStorage.setItem("roleAccess", encryptData(roleAccess));
      localStorage.setItem("username", encryptData(username));

      onLogin({
        username: username,
        nama,
        nickname,
        roleAccess,
      });
      // toast.success(`Hi!, ${nickname}`);
      navigate("/admin/dashboard");
    } catch (err) {
      message.error("Username atau password yang anda masukkan salah!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={`login-page theme-${currentTheme}`}>
        <Row style={{ minHeight: "100vh" }}>
          <Col
            xs={0}
            md={14}
            lg={16}
            style={{
              backgroundImage: `url(${LoginImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              transition: "opacity 240ms ease, filter 240ms ease",
            }}
            className="desktop-banner"
          />
          <Col xs={24} md={10} lg={8}>
            <Layout
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                padding: "28px",
                position: "relative",
              }}
            >
              <div style={{ position: "absolute", top: 16, right: 16, zIndex: 30 }}>
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>

                  <Switch
                    checked={currentTheme === "dark"}
                    onChange={(checked) => {
                      const newTheme = checked ? "dark" : "light";
                      setManualTheme(newTheme);
                      localStorage.setItem("loginTheme", newTheme);
                    }}
                    checkedChildren="🌙"
                    unCheckedChildren="☀️"
                  />

                  <span style={{ fontWeight: 600, color: currentTheme === "dark" ? "#fff" : "#000" }}>
                    {manualTheme === null ? "Auto" : currentTheme === "dark" ? "Dark" : "Light"}
                  </span>

                  {manualTheme !== null && (
                    <Button size="small" type="text" onClick={resetThemeAuto}>
                      Auto
                    </Button>
                  )}
                </div>
              </div>
              <div
                className="form-card"
                style={{
                  width: "100%",
                  maxWidth: 420,
                  marginTop: "auto",
                  marginBottom: "auto",
                  animation: "scaleIn 420ms cubic-bezier(.2,.9,.2,1)",
                }}
              >
                <div className="mobile-banner">
                  <img src={LoginImage} alt="banner" className="mobile-banner-img" />
                </div>

                <div style={{ textAlign: "center", marginBottom: 12 }}>
                  <img src={LogoIndak} alt="logo" width={72} style={{ borderRadius: 8 }} />
                  <Title level={3} style={{ marginTop: 8, marginBottom: 2 }}>
                    Sign in
                  </Title>
                </div>

                <Form layout="vertical" onFinish={onFinish}>
                  <Form.Item
                    label="Username"
                    name="username"
                    rules={[{ required: true, message: "Masukkan Username" }]}
                  >
                    <Input size="large" placeholder="Username" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: "Masukkan Password" }]}
                  >
                    <Input.Password
                      size="large"
                      placeholder="Password"
                      iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                    />
                  </Form.Item>

                  <Button type="primary" htmlType="submit" block size="large" loading={loading}>
                    Sign In
                  </Button>
                </Form>
                <div style={{ marginTop: 22, textAlign: "center" }}>
                  <Text type="secondary">
                    © {new Date().getFullYear()} <Link href="https://indak.com">Indak-Apps</Link>
                  </Text>
                  <br />
                  {/* <div className="dev-tag"> */}
                  <span className="dev-by">{lang === "ar" ? "تطوير بواسطة" : "Dev By"}</span>
                  <span className="dev-name">~ YallaBob ~</span>
                  {/* </div> */}
                  {/* <Text type="secondary">Dev By ~ YallaBob ~</Text> */}
                </div>
              </div>
            </Layout>
          </Col>
        </Row>
      </div>
      <style>{`
        :root {
          --light-bg: #ffffff;
          --light-card: #ffffff;
          --light-text: #111;
          --light-muted: #666;

          --dark-bg: #000000;
          --dark-card: #0d0d0d;
          --dark-text: #f3f3f3;
          --dark-muted: #9a9a9a;
        }

        /* Base Theme */
        .login-page.theme-light {
          background: var(--light-bg) !important;
          color: var(--light-text) !important;
        }
        .login-page.theme-dark {
          background: var(--dark-bg) !important;
          color: var(--dark-text) !important;
        }

        /* Form Card */
        .form-card {
          background: var(--light-card);
          border-radius: 12px;
          padding: 24px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.08);
          transition: 0.3s ease;
        }
        .login-page.theme-dark .form-card {
          background: var(--dark-card) !important;
          box-shadow: 0 8px 32px rgba(255,255,255,0.06);
        }

        /* Labels */
        .ant-form-item-label > label {
          font-weight: 600 !important;
        }
        .login-page.theme-light .ant-form-item-label > label {
          color: var(--light-text) !important;
        }
        .login-page.theme-dark .ant-form-item-label > label {
          color: var(--dark-text) !important;
        }

        /* Inputs */
        .login-page.theme-light .ant-input,
        .login-page.theme-light .ant-input-affix-wrapper,
        .login-page.theme-light .ant-input-password {
          background: #fff !important;
          color: #000 !important;
          border-color: #d9d9d9 !important;
        }

        .login-page.theme-dark .ant-input,
        .login-page.theme-dark .ant-input-affix-wrapper,
        .login-page.theme-dark .ant-input-password {
          background: #1a1a1a !important;
          color: #fff !important;
          border-color: #333 !important;
        }

        .login-page.theme-dark input::placeholder {
          color: rgba(255,255,255,0.35) !important;
        }
        .login-page.theme-light input::placeholder {
          color: rgba(0,0,0,0.35) !important;
        }

        /* Primary Button */
        .login-page.theme-light .ant-btn-primary {
          background: #1677ff !important;
          border-color: #1677ff !important;
        }
        .login-page.theme-dark .ant-btn-primary {
          background: #2f9cff !important;
          border-color: #2f9cff !important;
          box-shadow: 0 4px 14px rgba(47,156,255,0.25);
        }

        /* Mobile Banner */
        .mobile-banner {
          display: none;
          margin-bottom: 16px;
        }
        .mobile-banner-img {
          width: 100%;
          border-radius: 12px;
          transform: translateY(-12px);
          opacity: 0;
          animation: slideTop 0.5s ease forwards;
        }

        @keyframes slideTop {
          0% { opacity: 0; transform: translateY(-14px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        /* Responsive */
        @media(max-width: 768px) {
          .desktop-banner { display: none !important; }
          .mobile-banner { display: block !important; }
          .form-card { padding: 18px; }
        }

        /* Smooth transitions */
        * {
          transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;
        }
          /* Typography override for dark mode */
        .login-page.theme-dark .ant-typography,
        .login-page.theme-dark .ant-typography > * {
          color: var(--dark-text) !important;
        }

        /* For secondary text */
        .login-page.theme-dark .ant-typography-secondary {
          color: var(--dark-muted) !important;
        }

        /* For links */
        .login-page.theme-dark a {
          color: #4ea6ff !important;
        }
      `}</style>
    </>
  );
};

export default Login;